import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/react';

import ErrorScreen from 'components/lib/Error/ErrorScreen';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errorLogged: null, errorFound: false };
    this.setError = this.setError.bind(this);
  }

  static getDerivedStateFromError() {
    return { errorFound: true };
  }

  componentDidCatch(err) {
    this.setState({ errorFound: true });
    const context = { navPath: window.location.href };

    if (this.props.user?.organisation) {
      context.organisation = this.props.user.organisation._id;
    }
    const sentryUserContext = { user: {} };
    if (this.props.user?._id) {
      sentryUserContext.user = {
        id: this.props.user._id,
        username: this.props.user.profile.fullName,
        organisation: this.props.user.organisation.name,
        orgId: this.props.user.organisation._id,
      };
    }
    Sentry.captureException(err, sentryUserContext);
  }

  setError() {
    this.setState({ errorFound: false });
  }

  render() {
    const { errorFound } = this.state;
    if (errorFound) {
      return <ErrorScreen setError={this.setError} />;
    }
    return this.props.children;
  }
}

const mapStateToProps = (state) => ({ user: state.user });

export default withRouter(connect(mapStateToProps)(ErrorBoundary));
